<div class="month-selector" [ngClass]="customClass" *ngIf="months && months.length > 0">
  <button
    type="button"
    class="month-btn"
    *ngFor="let item of months; let i = index"
    [ngClass]="{ 'active': isItemActive(item, i) }"
    (click)="onSelectMonth(i, item)"
  >
    {{ formatMonthLabel(item) }}
  </button>
</div>
